import React from 'react';
import axios from 'axios';
import { Alert, Form, Input, DatePicker, Spin, Checkbox } from 'antd';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import passport from 'components/passportUtils';
import formItemLayout from 'components/Portal/formItemLayout';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import VisaWaive from './VisaWaive';

import stickyError from 'components/stickyError';

class VisaStatus extends React.Component {
	state = {
		loading: true,
		visas: [],
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) {
				this.props.isSubmitted();
				return stickyError(err.message);
			}
			let requests = [];
			for (let visa in values) {
				if (values[visa] !== null) {
					requests.push(axios.post(apiPath + '/visa', {
						code: visa,
						expiry_date: moment(values[visa]).format('YYYY-MM-DD')
					}, { withCredentials: true }));
				}
				else{
					requests.push(axios.post(apiPath + '/visa', {
						code: visa,
						expiry_date: ''
					}, { withCredentials: true }));
				}
			}
			axios.all(requests).then(result => {
				this.props.isSubmitted();
			}).catch(error => {
				this.props.isSubmitted();
				stickyError('One or more visa expiry dates may not have been saved, please try again.')
			});
		});
	}

	checked = (event) => {
		let eventClick = event.target
		this.setState({
			[eventClick.value]: event.target.checked
		})
	}

	componentWillMount() {
		axios.get(apiPath + '/visa', { withCredentials: true }).then(result => {
			this.setState({ visas: result.data, loading: false });
		})
			.catch(error => {
				stickyError('Error loading visa statuses');
			});
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'travel/visastatus');
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'travel/visastatus');
			if (redirect) return redirect;
		}

		const props = this.props;
		if ((props.remarksLoaded && !props.remarks.find(remark => remark.Code === 'VISAPRE' && remark.rmkNumericCheck1 === '1')) || !passport.isComplete(passport.parseFromFolio(props.folio))) {
			return <Alert showIcon type="error" message="Previous section required" description="Please fill out your passport details and agree to the pre-embarkation terms" />;
		}

		if (this.state.loading) return <Spin />;

		const { getFieldDecorator } = this.props.form;

		return (
			<div>
				<Form className="withSpacing" onSubmit={this.handleSubmit}>
					<p>
						Please check the status of your required visas here.
						When you obtain each required visa, please update the visa expiry date to change your status.
				</p>
					{this.state.visas.map(visa =>
						<Form.Item style={{ visibility: visa.VS_VISA_STATUS !== 'W' ? 'visible' : 'hidden' }} label={visa.COUNTRY_NAME} key={visa.VS_VISA_CODE} {...formItemLayout}>
							{getFieldDecorator(visa.VS_VISA_CODE, {
								initialValue: (visa.VS_EXPIRY_DATE) ? moment(visa.VS_EXPIRY_DATE) : null
							})(
								<DatePicker disabled={disabled} />
						)}
							</Form.Item>
					)}
					<SaveButton
						disabled={!this.props.form.isFieldsTouched()}
						loading={this.props.getStatus().submitting} />
				</Form>
				<br />
				{this.props.variant === 'admin' &&
				<VisaWaive />
				}
			</ div>
		);
	}
}

export default withSpin(Form.create()(VisaStatus));



// WEBPACK FOOTER //
// ./portal-components/Portal/Travel/VisaStatus.jsx